import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"

import Carousel from "../../atomic/molecules/Carousel"
import ProjectCard from "../../atomic/organisms/ProjectCard"

export default class ContentfulBlockProjectList extends React.Component {

  render() {

    const { mode, layout, data, transition, projects } = this.props

    return (
      <Container>
        <CarouselWrap>
          <Carousel
            id={"project-list"}
            mode={mode}
            slidesPerView={1.1}
            centeredSlides={true}
            spaceBetween={10}
          >
            {projects.map((project, i) => (
              <ProjectCard
                key={i}
                title={project.title}
                client={project.client}
                slug={project.slug}
                award={project.award}
                image={project.landscapeImage}
                transition={transition}
                stacked="vertical"
              />
            ))}
          </Carousel>
        </CarouselWrap>
        <Projects>
          {projects.map((project, i) => (
              <ProjectCard
                key={i}
                title={project.title}
                client={project.client}
                image={project.landscapeImage}
                slug={project.slug}
                award={project.award}
                transition={transition}
                stacked="grid"
              />
           ))}
        </Projects>
      </Container>
    )
  }

}

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;

  ${up("md")} {
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
`

const Text = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;

  ${up("md")} {
    min-width: 310px;
    flex-shrink: 1;
    margin-right: 60px;
    padding-left: 0px;
    padding-right: 0px;
  }
`

const Projects = styled.div`
  display: none;

  ${up("md")} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 2vh 2vh;
    grid-template-areas:
      ". ."
      ". .";
  }

  a:nth-child(3),
  a:nth-child(4){
    transform: translateX(6vh);
  }
`

const CarouselWrap = styled.div`
  display: block;
  padding-top: 30px;
  ${up("md")} {
    display: none;
  }
`